import { API_BASE_URL, parseIstatecResponse, type IstatecResponse } from './apiConfig';

export interface CountryCode {
  name: string;
  iso_code: string;
  dial_code: string;
}

interface CountryCodesData extends Record<string, unknown> {
  count: number;
  countries: CountryCode[];
}

export interface FetchCountryCodesResult {
  success: boolean;
  countries: CountryCode[];
  message?: string;
}

export async function fetchCountryCodes(search?: string): Promise<FetchCountryCodesResult> {
  try {
    const query = search && search.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
    const res = await fetch(`${API_BASE_URL}/country_codes${query}`, { method: 'GET' });
    const parsed = (await parseIstatecResponse(res)) as IstatecResponse<CountryCodesData | null>;
    if (parsed.status === 'success' && parsed.data && Array.isArray(parsed.data.countries)) {
      return { success: true, countries: parsed.data.countries };
    }
    return {
      success: false,
      countries: [],
      message: parsed.message || 'Failed to load country codes',
    };
  } catch {
    return {
      success: false,
      countries: [],
      message: 'Network error while loading country codes',
    };
  }
}
